import dayjs from 'dayjs';
import { AdvisorStatusEnum } from '@graphql/enums/dossiers';
import type { Customer, Property } from '@graphql/types/properties';

export const fullName = (customer: Customer) => {
  const infix = customer.infix ? customer.infix : ' ';
  return `${customer.first_name} ${infix} ${customer.last_name}`;
};

export const getPropertyTitle = (property: Property) => {
  const isValid = (value: string | null) => value !== '.' && value;

  if (
    property &&
    isValid(property.entity.street_name) &&
    isValid(property.entity.house_number) &&
    isValid(property.entity.city)
  ) {
    return `${property.entity.street_name} ${property.entity.house_number}, ${property.entity.city}`;
  }
  return 'Adres (nog) niet bekend';
};

export const getLatestUpdatedStatus = (properties: Property[]): string => {
  let mostRecentStatus = properties[0].advisor_status.text;
  let mostRecentDate: dayjs.Dayjs | null = null;

  if (properties.length > 1) {
    for (const [index] of properties.entries()) {
      if (properties[index].advisor_status.text !== 'Gestopte aanvraag') {
        const currentDate = dayjs(properties[index].status_updated_at);

        if (!mostRecentDate || currentDate.isAfter(mostRecentDate)) {
          mostRecentStatus = properties[index].advisor_status.text;
          mostRecentDate = currentDate;
        }
      }
    }
  }

  return mostRecentStatus;
};

export const quickscanIsApproved = (status: string) => ![
  'refinancing',
  'ready_no_address',
  'easylane-ready',
  'ready',
  'waiting-for-pieces',
  'prepare-quotation',
  'waiting-for-compliance',
  'closed',
  'cancel',
].includes(status);

export const getStepIcon = (status: AdvisorStatusEnum): string => {
  const stepIcons = {
    [AdvisorStatusEnum.PREPARED]: 'file-pen',
    [AdvisorStatusEnum.READY_MEETING]: 'file-pen',
    [AdvisorStatusEnum.PREPARING_IM]: 'file-pen',
    [AdvisorStatusEnum.SCHEDULING_APPOINTMENT_PREPARE]: 'file-pen',
    [AdvisorStatusEnum.WAITING_ON_SIGNED_QUOTE_GREENLIGHT]: 'file-pen',
    [AdvisorStatusEnum.BRIEFING_NOTARY]: 'file-pen',
    [AdvisorStatusEnum.INFORM_NOTARY]: 'file-pen',
    [AdvisorStatusEnum.BRIEFING_NOTARY_WAITING]: 'memo-circle-check',
    [AdvisorStatusEnum.VERIFY_NOTARY]: 'memo-circle-check',
    [AdvisorStatusEnum.GOING_TO_PASS]: 'calendar-week',
    [AdvisorStatusEnum.WAITING_FOR_DEED]: 'calendar-week',
    [AdvisorStatusEnum.WAITING_ON_SIGNED_ACCEPTANCE]: 'house-circle-check',
    [AdvisorStatusEnum.WAITING_ON_SIGNED_ACCEPTANCE_SIGN]: 'house-circle-check',
    [AdvisorStatusEnum.IS_OFFER]: 'house-laptop',
    [AdvisorStatusEnum.REALIZED]: 'party-horn',
  };

  return stepIcons[status] ?? 'hourglass-clock';
};
